import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router/index.js'

import { initUserSession } from './features/useUser.js'

import i18n from '@/i18n'

import './styles/root.css'
import './styles/global.css'
import './styles/components.css'
import './styles/layout/loading-overlay.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)

/* Resolve the session once before mount so the first paint matches auth
   state. The router guard awaits the same cached `initPromise`, so boot
   and deep-link navigations share one restore — no parallel races. */
await initUserSession(router)

app.mount('#app')
